import * as Contentful from 'contentful'

import { TypeSectionFields, SectionContent } from './section'
import { TypeItemFeatureHighlight } from './item-feature-highlight'
import { TypeAlignment } from './alignment'

export enum TwoColumnProportion {
  OneToOne = '1:1',
  OneToTwo = '1:2',
  TwoToOne = '2:1',
  FiveToSeven = '5:7',
  SevenToFive = '7:5',
}

export enum TwoColumnGapType {
  M = 'M',
}

export enum CollapseToSingleColumnBreakpoints {
  large = 'large',
  medium = 'medium',
  small = 'small',
}

export interface TypeSectionTwoColumnFields extends TypeSectionFields {
  heading?: TypeItemFeatureHighlight
  columnsProportion: TwoColumnProportion
  leftColumnAlignment?: TypeAlignment
  leftColumnContent: SectionContent | undefined
  rightColumnAlignment?: TypeAlignment
  rightColumnContent: SectionContent | undefined
  reverseOrderWhenVertical?: boolean
  gutterGap?: TwoColumnGapType
  collapseToSingleColumnBreakpoint?: CollapseToSingleColumnBreakpoints
}

export type TypeSectionTwoColumn = Contentful.Entry<TypeSectionTwoColumnFields>
